import script from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=c9ce7e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9ce7e74"]])

export default __exports__